import "../styles/MainFooter.css";
import logo from "../assets/images/hi-tech-board-logo.png";
// Import certification PNG images (make sure these exist in your assets)
import recycleIcon from "../assets/images/recycle.png";
import fscIcon from "../assets/images/fsc.png";
import isoIcon from "../assets/images/iso.png";
import reachIcon from "../assets/images/reach-logo.png";
import rohsIcon from "../assets/images/rohs-logo.png";
import { Link } from "react-router-dom";

const MainFooter = () => {
  const currentYear = new Date().getFullYear();
  
  return (
    <footer className="main-footer">
      <div className="container">
        <div className="row g-5">
          {/* Column 1: Brand & About */}
          <div className="col-lg-4 col-md-6">
            <div className="footer-brand ">
              <div className="logo-wrapper">
                <img
                  src={logo}
                  alt="Sri Krishna Hi-Tech Paper Board Logo"
                  className="footer-logo"
                />
              </div>
              <div className="company-info">
                <h3 className="company-name">SRI KRISHNA</h3>
                <h4 className="company-tagline">HI-TECH PAPER BOARD</h4>
              </div>
            </div>
            <p className="company-description">
              Leading manufacturer of premium quality Kappa boards and packaging solutions. 
              Committed to innovation, sustainability, and excellence since 2017.
            </p>
            
            {/* Certification Badges */}
            <div className="certification-badges mt-4">
              <div className="badge-item">
                <img src={recycleIcon} alt="Recyclable" className="cert-badge" />
                <span>Eco-Friendly</span>
              </div>
              <div className="badge-item">
                <img src={fscIcon} alt="FSC Certified" className="cert-badge fsc" />
                <span>FSC Certified</span>
              </div>
              <div className="badge-item">
                <img src={isoIcon} alt="ISO Certified" className="cert-badge-iso" />
                <span>ISO Certified</span>
              </div>
              <div className="badge-item">
                <img src={reachIcon} alt="FSC Certified" className="cert-badge" />
                <span>Reach Certificate</span>
              </div>
              <div className="badge-item">
                <img src={rohsIcon} alt="FSC Certified" className="cert-badge" />
                <span>ROHS Certificate</span>
              </div>
            </div>
          </div>

          {/* Column 2: Quick Links */}
          <div className="col-lg-2 col-md-6">
            <h5 className="footer-title">Quick Links</h5>
            <ul className="footer-nav">
              <li><Link to="/">Home</Link></li>
              <li><Link to="/about">About Us</Link></li>
              <li><Link to="/products">Products</Link></li>
              <li><Link to="/contact">Contact Us</Link></li>
            </ul>
          </div>

          {/* Column 3: Contact Information */}
          <div className="col-lg-3 col-md-6">
            <h5 className="footer-title">Contact Us</h5>
            <div className="contact-info">
              <div className="contact-item">
                <i className="bi bi-geo-alt"></i>
                <div>
                  <strong>Address</strong>
                  <p>No: 2/357, Thulukkankuruchi,
Vembakottai (T.K),<br/>
Sivakasi - 626140,<br/>
Virudhunagar - District,<br/>
Tamil Nadu.</p>
                </div>
              </div>
              <div className="contact-item">
                <i className="bi bi-telephone"></i>
                <div>
                  <strong>Phone</strong>
                  <p>+91 97871 82226</p>
                </div>
              </div>
              <div className="contact-item">
                <i className="bi bi-envelope"></i>
                <div>
                  <strong>Email</strong>
                  <p>srikrishnahitechpaperboard@gmail.com</p>
                </div>
              </div>
              <div className="contact-item">
                <i className="bi bi-clock"></i>
                <div>
                  <strong>Business Hours</strong>
                  <p>24 X 7</p>
                </div>
              </div>
            </div>
          </div>

          {/* Column 4: Social Media */}
          <div className="col-lg-3 col-md-6">
            <h5 className="footer-title">Connect With Us</h5>
            <p className="social-description">
              Follow us for updates and industry insights
            </p>
            <div className="social-media">
              <a href="/" className="social-link" aria-label="Facebook">
                <i className="bi bi-facebook"></i>
              </a>
              <a href="/" className="social-link" aria-label="Twitter">
                <i className="bi bi-twitter-x"></i>
              </a>
              <a href="/" className="social-link" aria-label="LinkedIn">
                <i className="bi bi-linkedin"></i>
              </a>
              <a href="/" className="social-link" aria-label="Instagram">
                <i className="bi bi-instagram"></i>
              </a>
              <a href="/" className="social-link" aria-label="YouTube">
                <i className="bi bi-youtube"></i>
              </a>
            </div>
            
            <div className="quality-assurance mt-4">
              <h6>Quality Assurance</h6>
              <p className="quality-text">
                All products undergo rigorous quality checks ensuring superior standards.
              </p>
            </div>
          </div>
        </div>
        
        {/* Footer Bottom - Modified */}
        <div className="footer-bottom">
          <div className="row align-items-center">
            <div className="col-lg-6 col-md-12">
              <p className="copyright">
                © {currentYear} SRI KRISHNA HI-TECH PAPER BOARD. All Rights Reserved.
              </p>
            </div>
            <div className="col-lg-6 col-md-12">
              <div className="footer-links">
                <span className="developer-credit">
                  Developed by{" "}
                  <a 
                    href="https://aatheshsoft.com/" 
                    target="_blank" 
                    rel="noopener noreferrer"
                    className="developer-link"
                  >
                    Aathesh Soft
                  </a>
                </span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default MainFooter;